import { render } from "./ShieldIcon.vue?vue&type=template&id=c69db484&scoped=true"
import script from "./ShieldIcon.vue?vue&type=script&lang=js"
export * from "./ShieldIcon.vue?vue&type=script&lang=js"

import "./ShieldIcon.vue?vue&type=style&index=0&id=c69db484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c69db484"]])

export default __exports__